import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { InfoIcon } from "lucide-react";

interface UploadProcessConfirmationDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    fileCount: number;
}

export default function UploadProcessConfirmationDialog({
    isOpen,
    onClose,
    onConfirm,
    fileCount,
}: UploadProcessConfirmationDialogProps) {
    const isSingle = fileCount === 1;

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                            <InfoIcon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                        </div>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            Upload & Process CVs
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-sm text-gray-600 dark:text-gray-400 space-y-4">
                        <p>
                            You're about to upload{" "}
                            <span className="font-medium text-gray-900 dark:text-gray-100">
                                {fileCount} {isSingle ? "CV" : "CVs"}
                            </span>
                            .
                        </p>

                        <p>
                            We'll extract candidate details and add them to the{" "}
                            <span className="font-semibold text-gray-900 dark:text-gray-100">
                                Uploads
                            </span>{" "}
                            tab for review before moving them into your hiring pipeline.
                        </p>

                        <p>
                            This may take a few moments, depending on the number of files
                            uploaded.
                        </p>
                    </DialogDescription>
                </DialogHeader>

                <div className="flex gap-3 justify-end mt-4">
                    <Button variant="outline" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Continue
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
